<h2 class="mt-4">{{cardConfiguration.title}}
  <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberPaymentInfo.BankAccount' | translate}}"></span>
</h2>

<ng-container *ngIf="isVersion2()">
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label>
          <span *ngIf="voluntary === true" class="mandatory">*</span>
          {{'CardSubscriberPaymentInfo.BankAccountType' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberPaymentInfo.BankAccountType' | translate}}"></span>
        </label>
        <!--[required]="voluntary === true"-->
        <select class="custom-select" [(ngModel)]="cardData.bankAccountTypeCode"
                [required]="voluntary === true"
                name="bankAccountTypeCode" #bankAccountTypeCode="ngModel"
                [dropdownTitle]="{value : cardData.bankAccountTypeCode, dimensions : bankAccountTypes }"
                [clearRelated]="{model : this.cardData , propsToReset : ['iban','soleOwner','coOwnerInfo']} "
                >
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of bankAccountTypes" [value]="domain.code" [disabled]="isInPt() === false && domain.code === 'N'" [ngStyle]="{'font-weight': isInPt() === false && domain.code === 'I' ? 'bold' : ''}">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="bankAccountTypeCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label>
          <span *ngIf="cardData.bankAccountTypeCode === 'N'" class="mandatory">*</span>
          {{'CardSubscriberPaymentInfo.Iban' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberPaymentInfo.Iban' | translate}}"></span>
        </label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardSubscriberPaymentInfo.Iban' | translate}}"
               [(ngModel)]="cardData.iban" #iban="ngModel" name="iban"
               [required]="cardData.bankAccountTypeCode === 'N'" 
               ibanValidation
               [pattern]="cardData.bankAccountTypeCode == 'N' ? '^(PT|pt|Pt|pT)50.*' : ''" maxlength="30"
               [disabled]="cardData.bankAccountTypeCode === 'I' && isInPt() === true">
        <validation-message [control]="iban"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.bankAccountTypeCode === 'I' && isInPt() === true">
          <label [ngClass]="cardData.bankAccountTypeCode !== 'N' && cardData.bankAccountTypeCode !== 'I'? 'disabled' : '' ">
            <span *ngIf="cardData.bankAccountTypeCode === 'N' || (cardData.bankAccountTypeCode === 'I' && isInPt() === false)" class="mandatory">*</span>
            {{'CardSubscriberPaymentInfo.SoleOwner' | translate}}
          </label>
          <div class="btn-group btn-group-toggle">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.soleOwner" [radioLabel]="soleOwner">
              <input type="radio" [(ngModel)]="cardData.soleOwner" #soleOwner="ngModel" name="soleOwner" [value]="domain.value"
                     [clearRelated]="{model : this.cardData , propsToReset : ['coOwnerInfo']} "
                     [required]="cardData.bankAccountTypeCode === 'N'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <div class="col-sm-8">
      <div class="form-group">
        <label for="CoOwner" [class.disabled]="!cardData.soleOwner || cardData.soleOwner?.toString() == 'true'">
          <span class="mandatory" *ngIf="cardData.soleOwner && cardData.soleOwner?.toString() != 'true'">*</span>{{'CardSubscriberPaymentInfo.CoOwner' | translate}}
        </label>
        <input class="form-control" type="text"
               maxlength="60"
               placeholder="{{'Placeholders.CardSubscriberPaymentInfo.CoOwner' | translate}}"
               [(ngModel)]="cardData.coOwnerInfo" #coOwnerInfo="ngModel" name="coOwnerInfo"
               [required]="cardData.soleOwner && cardData.soleOwner?.toString() != 'true'" [disabled]="!cardData.soleOwner || cardData.soleOwner?.toString() == 'true'">
        <validation-message [control]="coOwnerInfo"></validation-message>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isVersion2()">
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label>
          {{'CardSubscriberPaymentInfo.BankAccountType' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberPaymentInfo.BankAccountType' | translate}}"></span>
        </label>

        <select class="custom-select" [(ngModel)]="cardData.bankAccountTypeCode" name="bankAccountTypeCode" #bankAccountTypeCode="ngModel"
                [dropdownTitle]="{value : cardData.bankAccountTypeCode, dimensions : bankAccountTypes }">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of bankAccountTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="bankAccountTypeCode"></validation-message>
      </div>
    </div>


    <div class="col-sm-4">
      <div class="form-group">
        <label>{{'CardSubscriberPaymentInfo.Iban' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberPaymentInfo.Iban' | translate}}"></span>
        </label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardSubscriberPaymentInfo.Iban' | translate}}"
               [(ngModel)]="cardData.iban" #iban="ngModel" name="iban"
               ibanValidation
               [pattern]="cardData.bankAccountTypeCode == 'N' ? '^(PT|pt|Pt|pT)50.*' : ''" maxlength="30">
        <validation-message [control]="iban"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label>{{'CardSubscriberPaymentInfo.SoleOwner' | translate}}</label>
        <div class="btn-group btn-group-toggle">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.soleOwner">
            <input type="radio" [(ngModel)]="cardData.soleOwner" name="soleOwner" [value]="domain.value"
                   [clearRelated]="{model : this.cardData , propsToReset : ['coOwnerInfo']} ">
            {{domain.description}}
          </label>
          <validation-message class="invisible" [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-8">
      <div class="form-group">
        <label for="CoOwner" [class.disabled]="!cardData.soleOwner || cardData.soleOwner?.toString() == 'true'">
          <span class="mandatory" *ngIf="cardData.soleOwner && cardData.soleOwner?.toString() != 'true'">*</span>{{'CardSubscriberPaymentInfo.CoOwner' | translate}}
        </label>
        <input class="form-control" type="text"
               maxlength="60"
               placeholder="{{'Placeholders.CardSubscriberPaymentInfo.CoOwner' | translate}}"
               [(ngModel)]="cardData.coOwnerInfo" #coOwnerInfo="ngModel" name="coOwnerInfo"
               [required]="cardData.soleOwner && cardData.soleOwner?.toString() != 'true'" [disabled]="!cardData.soleOwner || cardData.soleOwner?.toString() == 'true'">
        <validation-message [control]="coOwnerInfo"></validation-message>
      </div>
    </div>
  </div>
</ng-container>
<!--<pre>{{cardData | json}}</pre>-->
